import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    apiBaseUrl: '/api/idp',
    sapBusinessApiBaseUrl: '/api/sap-business',
    oneWelcomeApiBaseUrl: '/api',
    authClientId: '6aff50c4-54bc-4e77-8130-4fb3d26496e0',
    authAuthority: 'https://login.microsoftonline.com/64458159-0d9a-4d84-966f-1a13c0ac7a34',
    authRedirectUri: 'https://accnsaccountmanagement.ns.nl'
    // authRedirectUri: 'http://localhost:4200'
};
